import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20geometric%20network%20connection%20patterns%20in%20amber%20and%20gold%20tones%2C%20minimalist%20professional%20atmosphere%2C%20modern%20clean%20aesthetic%2C%20subtle%20dot%20matrix%20texture%2C%20elegant%20corporate%20style&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="好联系 - 人脉管理平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 tracking-tight">
          {heroData.title}
        </h1>
        <p className="text-lg md:text-2xl text-white/90 font-medium mb-6">
          {heroData.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          {heroData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={heroData.ctaPrimaryHref}
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md text-base font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            {heroData.ctaPrimary}
          </Link>
          <Link
            to={heroData.ctaSecondaryHref}
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-md text-base font-medium hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            {heroData.ctaSecondary}
          </Link>
        </div>
      </div>
    </section>
  );
}